import { DataLogRq, SourcePage } from '@domain/rq/DataLog';
import {
  EducationLevelType,
  EducationStatusType,
  MajorType,
  Score,
  ScoreType,
} from '@domain/constant/profile/EducationType';
import DateFormat from '@utils/date/format';

export class ProfileResearchAttachFileVO {
  fileUid: string;
  fileName: string;

  constructor(dto: ProfileResearchAttachFileVO) {
    this.fileUid = dto.fileUid;
    this.fileName = dto.fileName;
  }
}

export class ProfileMajorUpdateVO {
  majorType: MajorType; // 전공 타입
  majorCode: number | null; // 학과 code
  majorName: string; // 학과 이름
  scoreType: ScoreType | null; // 학점 타입
  score: number | null; // 학점
  perfectScore: number | null; // 만점

  constructor(dto: ProfileMajorUpdateVO) {
    this.majorType = dto.majorType;
    this.majorCode = dto.majorCode;
    this.majorName = dto.majorName;
    this.scoreType = dto.scoreType ?? Score.SCORE; //학점 타입 기본 값 : 학점
    this.score = dto.score;
    this.perfectScore = dto.perfectScore;
  }
}

export class ProfileResearchUpdateVO {
  attachFiles: ProfileResearchAttachFileVO[]; // 첨부파일 리스트
  description: string; // 논문 설명

  constructor(dto: ProfileResearchUpdateVO) {
    this.attachFiles = dto.attachFiles.map((dto) => new ProfileResearchAttachFileVO(dto));
    this.description = dto.description;
  }
}

export class ProfileEducationUpdateVO {
  schoolLevel: EducationLevelType | null; // 학교 종류
  educationType: EducationStatusType | null; // 학력 상태
  transferYn: boolean; //편입 상태
  startDate?: string; // 재학 시작일시
  endDate?: string | null; // 재학 종료일시
  schoolCode: number | null; // 학교 코드
  schoolName: string | null; // 학교명
  profileMajors: ProfileMajorUpdateVO[]; // 전공 리스트
  profileResearches: ProfileResearchUpdateVO[]; // 연구 분야 및 논문 리스트
  sourcePage?: SourcePage;

  constructor(dto: ProfileEducationUpdateVO & DataLogRq) {
    this.schoolLevel = dto.schoolLevel;
    this.educationType = dto.educationType;
    this.transferYn = dto.transferYn;
    this.startDate = DateFormat.getDateFormatString(dto.startDate, 'yyyy-MM');
    this.endDate = DateFormat.getDateFormatString(dto.endDate, 'yyyy-MM');
    this.schoolCode = dto.schoolCode;
    this.schoolName = dto.schoolName;
    this.profileMajors = dto.profileMajors.map((dto) => new ProfileMajorUpdateVO(dto));
    this.profileResearches = dto.profileResearches
      ?.map((dto) => new ProfileResearchUpdateVO(dto))
      .filter((dto) => {
        return dto.attachFiles?.length || dto.description;
      });
    this.sourcePage = dto.sourcePage;
  }
}

export default class ProfileEducationRq {
  educationLevel: EducationLevelType; // 최종 학력
  educations: ProfileEducationUpdateVO[];
  sourcePage?: SourcePage;

  constructor(rq: ProfileEducationRq & DataLogRq) {
    this.educationLevel = rq.educationLevel;
    this.educations = rq.educations.map((dto) => new ProfileEducationUpdateVO(dto));
    this.sourcePage = rq.sourcePage;
  }
}
